const showCartUpdate = (form) => {
  form?.querySelector('[data-cart-update-row]')?.removeAttribute('hidden');
  form?.querySelector('.sc-cart-update')?.removeAttribute('hidden');
};

let cartUpdateTimer;
const queueCartUpdate = (form) => {
  if (!form) return;
  showCartUpdate(form);
  const status = form.querySelector('[data-cart-update-status]');
  const checkout = form.querySelector('[name="checkout"]');
  if (status) status.textContent = 'Updating totals…';
  if (checkout) checkout.disabled = true;
  window.clearTimeout(cartUpdateTimer);
  cartUpdateTimer = window.setTimeout(() => {
    const updateButton = form.querySelector('button[name="update"]');
    if (updateButton && typeof form.requestSubmit === 'function') {
      form.requestSubmit(updateButton);
      return;
    }
    form.submit();
  }, 650);
};

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-cart-minus], [data-cart-plus]');
  if (!button) return;
  const input = button.parentElement?.querySelector('input[name="updates[]"]');
  if (!input) return;
  const next = Math.max(0, Number(input.value || 0) + (button.hasAttribute('data-cart-plus') ? 1 : -1));
  input.value = String(next);
  queueCartUpdate(button.closest('form'));
});

document.addEventListener('change', (event) => {
  if (!event.target.matches('input[name="updates[]"]')) return;
  queueCartUpdate(event.target.closest('[data-sc-cart-page] form'));
});
